import { render, staticRenderFns } from "./pre_base_tan_detail.vue?vue&type=template&id=25ae3584&scoped=true"
import script from "./pre_base_tan_detail.vue?vue&type=script&lang=js"
export * from "./pre_base_tan_detail.vue?vue&type=script&lang=js"
import style0 from "./pre_base_tan_detail.vue?vue&type=style&index=0&id=25ae3584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae3584",
  null
  
)

export default component.exports